import { Component, Optional } from '@angular/core'
import { OrderSummaryComponent } from '@spartacus/cart/base/components'
import { OutletContextData } from '@spartacus/storefront'
import { Subscription } from 'rxjs'
import { SharedService } from '../../../../services/shared/shared.service'

@Component({
    selector: 'app-custom-order-summary',
    templateUrl: './custom-order-summary.component.html',
    styleUrls: ['./custom-order-summary.component.scss'],
    standalone: false
})
export class CustomOrderSummaryComponent extends OrderSummaryComponent {
  protected subscription = new Subscription()

  //  cart: Cart;

  constructor(
    public sharedService: SharedService,
    @Optional() protected outlet?: OutletContextData<any>
  ) {
    super()
  }

  ngOnInit(): void {
    if (this.outlet?.context$) {
      this.subscription.add(this.outlet.context$.subscribe((context) => (this.cart = context)))
    }
  }
}
